import { AnyAction } from "redux";
import { AdditionalProductsState } from "../../../../../models/state";
import { fulfilled, pending, rejected } from "../../utils";
import {
    RETAILER_FETCH_ADDITIONAL_SERVICES,
    RETAILER_FETCH_EXTRA_SIM_PRICES,
    RETAILER_ADD_SERVICES_FROM_RETAILER_FLOW,
} from "../actionTypes";

const initialState: AdditionalProductsState = {};

const additionalProductsReducer = (state = initialState, action: AnyAction): AdditionalProductsState => {
    switch (action.type) {
        case pending(RETAILER_FETCH_ADDITIONAL_SERVICES):
            return {
                ...state,
                [action.meta.memberId]: {
                    ...state[action.meta.memberId],
                    addedProducts: [],
                    products: [],
                    isLoading: true,
                    error: undefined,
                },
            };

        case RETAILER_ADD_SERVICES_FROM_RETAILER_FLOW:
            return {
                ...state,
                [action.meta.memberId]: {
                    ...state[action.meta.memberId],
                    addedProducts: [...(action.payload || [])],
                    isLoading: false,
                    error: undefined,
                },
            };
        case fulfilled(RETAILER_FETCH_ADDITIONAL_SERVICES):
            return {
                ...state,
                [action.meta.memberId]: {
                    ...state[action.meta.memberId],
                    products: action.payload?.products || [],
                    addedProducts: action.payload?.addedProducts || [],
                    isLoading: false,
                    error: undefined,
                },
            };
        case rejected(RETAILER_FETCH_ADDITIONAL_SERVICES):
            return {
                ...state,
                [action.meta.memberId]: {
                    ...state[action.meta.memberId],
                    addedProducts: [],
                    products: [],
                    isLoading: false,
                    error:
                        action.payload?.displayableMessage || "Vi beklager, men vi fikk ikke hentet tilleggstjenester.",
                },
            };
        case fulfilled(RETAILER_FETCH_EXTRA_SIM_PRICES):
            return {
                ...state,
                [action.meta.memberId]: {
                    extraSim: {
                        dataSimPrice: action.payload.extraDataSimPrice,
                        tvillingSimPrice: action.payload.extraTvillingSimPrice,
                        hasExistingExtraDataSim: action.payload.hasExistingExtraDataSim,
                    },
                },
            };

        default:
            return state;
    }
};

export default additionalProductsReducer;
